import * as React from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import IconButton from "@mui/material/IconButton";
import {Delete, Email, Phone, Visibility} from "@mui/icons-material";
import {Tooltip} from "@mui/material";
import {useState} from "react";

export const UserBasicCard = ({user, viewUser}) => {
    const [openDownloadModal, setOpenDownloadModal] = useState(false);

    return (
        <div style={{display: 'flex'}}>
            <Card sx={{maxWidth: 275, minWidth: 275}}>
                <CardContent>
                    {
                        user.familyName && user.givenName ?
                            <Typography sx={{mb: 1.5}} variant="h5" component="div">
                                {`${user.familyName} ${user.givenName}`}
                            </Typography>
                            :
                            null
                    }

                    {
                        user.email ?
                            <Typography sx={{mb: 1.5}} color="text">
                                <Email/> {`${user.email}`}
                            </Typography>
                            :
                            null
                    }



                    {
                        user.phoneNumber  ?
                            <Typography sx={{mb: 1.5}} color="text">
                               <Phone/> {`${user.phoneNumber}`}
                            </Typography>
                            :
                            null
                    }

                </CardContent>
                <CardActions sx={{display: "flex", flexDirection: "row-reverse", marginRight: "1rem"}}>
                    <Tooltip title={'Delete'}>
                        <IconButton color={"error"} size="small"><Delete/></IconButton>
                    </Tooltip>

                    <Tooltip title={'See full user details'}>
                        <IconButton onClick={() => viewUser(user)} color={"success"} size="small"><Visibility/></IconButton>
                    </Tooltip>
                </CardActions>
            </Card>
        </div>
    );
}
